import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Stack,
  TextField,
  Typography,
  LinearProgress,
  colors,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  ListItemText,
  Checkbox, Autocomplete
} from "@mui/material";
import logo from "../../assets/images/merchantnewlogo.svg";
import banner from "../../assets/images/3d-render-tax-payment-financial-business-concept.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import baseUrl from "../../config/baseUrl";
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

const icon = <CheckBoxOutlineBlankOutlinedIcon fontSize="small" />;
const checkedIcon = <CheckBoxOutlinedIcon fontSize="small" />;

const IncompleteProfile = () => {
  const navigate = useNavigate();
  const [payoutCountryOptions, setPayoutCountryOptions] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [currentForm, setCurrentForm] = useState(1);
  const totalForms = 7;

  const checkTokenExpiry = () => {
    const storedToken = sessionStorage.getItem('authToken');
    if (storedToken) {
        const tokenData = storedToken;
        if (Date.now() > tokenData.expiry) {
            sessionStorage.removeItem('authToken');
            alert('Session expired. Please log in again.');
            navigate('/merchant');
        }
    } else {
        sessionStorage.removeItem('authToken');
        alert('Session expired. Please log in again.');
        navigate('/merchant');
    }
  };

  useEffect(() => {
    checkTokenExpiry();
  }, []);

  const scheduleAutoLogout = () => {
    const storedToken = sessionStorage.getItem('authToken');
    if (!storedToken) return;
    if(storedToken === 'undefined'){
        sessionStorage.removeItem('authToken');
        alert('Session expired. Please log in again.');
        navigate('/merchant');
    }

    const tokenData = storedToken;
    const timeLeft = tokenData.expiry - Date.now();
    if (timeLeft > 0) {
        setTimeout(() => {
            alert('Session expired. Please log in again.');
            sessionStorage.removeItem('authToken');
            navigate('/merchant');
        }, timeLeft);
    }
 };

  const [formData, setFormData] = useState({
    bname: "",
    busines_Code: "",
    blocation: "",
    busines_Country: "",
    company_website_target_live_date: "",
    trading_dba: "",
    payoutCountries: "",
    fname: "",
    lname: "",
    main_contact_email: "",
    solution_apply_for_country: "",
    mode_of_solution: "",
    director1_name: "",
    director1_dob: "",
    director1_nationality: "",
    director2_name: "",
    director2_dob: "",
    director2_nationality: "",
    shareholder1_name: "",
    shareholder1_dob: "",
    shareholder1_nationality: "",
    shareholder2_name: "",
    shareholder2_dob: "",
    shareholder2_nationality: "",
    comp_officer_name: "",
    comp_officer_phone: "",
    comp_officer_email: "",
    comp_officer_address: "",
    website: "",
    job_title: "",
    company_estimated_monthly_volume: "",
    company_avarage_ticket_size: "",
    bankName: "",
    accountNumber: "",
    bankAddress: "",
    swift: "",
    settle_currency: "",
    usdt_wallet_address: "",
    question_id1: "",
    question_id2: "",
    question_id3: "",
    answer1: "",
    answer2: "",
    answer3: "",
  });

  const ReadData = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };
      let response = await axios.post(`${baseUrl}/incomplete`, {}, config);
      let result = await axios.post(`${baseUrl}/countrySelect`, {}, config);
      setFormData(response.data.data)
      setPayoutCountryOptions(result.data.result)
    } catch (error) {
      console.log(error);
    }
  };


  async function fetchQus() {
    try {
      const token = sessionStorage.getItem("authToken");
      let formData = new FormData();
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };
      let result = await axios.post(`${baseUrl}/fetchQus`, formData, config);
      if (result.data.status && result.data.data.length) {
        const randomQuestions = result.data.data
          .sort(() => 0.5 - Math.random())
          .slice(0, 3)
          .map((q, index) => ({
            label: q.question,
            name: `answer${index + 1}`, // Corrected here
            questionId: q.id,
          }));
  
        setQuestions(randomQuestions);
  
        // 🌟 SET question IDs in formData
        setFormData(prev => ({
          ...prev,
          question_id1: randomQuestions[0]?.questionId || "",
          question_id2: randomQuestions[1]?.questionId || "",
          question_id3: randomQuestions[2]?.questionId || "",
        }));
      }
    } catch (error) {
      console.log(error);
    }
  }
  
  const handleChangeAnswers = (e, question) => {
    const value = e.target.value;
    const { name, questionId  } = question;
  
    setFormData(prev => ({
      ...prev,
      [name]: {
        value: value,
        question_id: questionId 
      }
    }));
  };

  useEffect(() => {
    ReadData(); 
  }, []);

  useEffect(() => {
    fetchQus(); 
  }, []);


  const apiEndpoints = [
    "/save_company_profile",
    "/save-country-solution-apply",
    "/save-director-info",
    "/save_shareholder_info",
    // "/save_compliance_info",
    "/save_business_info",
    "/save_settelment_info",
    "/qusAns",
  ];

  useEffect(() => {
    AOS.init({
      duration: 1500,
      offset: 100,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [currentForm]);

  const formFieldsByStep = [
    ["bname", "blocation", "busines_Code", "busines_Country", "company_website_target_live_date", "trading_dba", "payoutCountries", "fname", "lname", "main_contact_email"],
    ["solution_apply_for_country", "mode_of_solution"],
    ["director1_name", "director1_dob", "director1_nationality", "director2_name", "director2_dob", "director2_nationality"],
    ["shareholder1_name", "shareholder1_dob", "shareholder1_nationality", "shareholder2_name", "shareholder2_dob", "shareholder2_nationality"],
    // ["comp_officer_name", "comp_officer_phone", "comp_officer_email", "comp_officer_address"],
    ["website", "job_title", "company_estimated_monthly_volume", "company_avarage_ticket_size"],
    ["settle_currency", "usdt_wallet_address"],
    ["question_id1", "question_id2", "question_id3", "answer1", "answer2", "answer3"],
  ];



  const handleChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [fieldName]: typeof value === 'string' ? value.split(',') : value,  // if value is string (comma-separated), split it
    }));
  };
  

  const submitForm = async () => {
    const token = sessionStorage.getItem('authToken');
    if (!token) return false; // failure

    try {
      const apiUrl = apiEndpoints[currentForm - 1];
      const relevantFields = formFieldsByStep[currentForm - 1];

      const dataToSend = relevantFields.reduce((acc, key) => {
        if (formData[key]) {
          // Yahan array check aur handle
          if (Array.isArray(formData[key])) {
            acc[key] = formData[key].join(', '); // Array ko comma-separated string bana diya
          } else {
            acc[key] = formData[key];
          }
        }
        return acc;
      }, {});

      const response = await axios.post(`${baseUrl}${apiUrl}`, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        alert(response.data.message);
        scheduleAutoLogout();

        if (currentForm === 7) {
          sessionStorage.removeItem("authToken");
          setFormData({});
          navigate("/DepositPortal");
        }

        return true; // success
      } else {
        console.error(`Unexpected Status: ${response}`);
        alert("Something went wrong. Please try again.");
        return false; // failure
      }
    } catch (error) {
      console.error(`Step ${currentForm} API Error:`, error);
      alert(error.message || "API error occurred.");
      return false; // failure
    }
  };

  const nextForm = async () => {
    const isSuccess = await submitForm();
    if (isSuccess && currentForm < totalForms) {
      setCurrentForm(currentForm + 1);
    }
  };


  const prevForm = () => {
    if (currentForm > 1) setCurrentForm(currentForm - 1);
  };

  const renderForm = () => {
    switch (currentForm) {
      case 1: return <BusinessForm payoutCountryOptions={payoutCountryOptions} handleChange={handleChange} formData={formData} />;
      case 2: return <SolutionsForm payoutCountryOptions={payoutCountryOptions} handleChange={handleChange} formData={formData} />;
      case 3: return <DirectorsForm handleChange={handleChange} formData={formData} />;
      case 4: return <ShareholderForm handleChange={handleChange} formData={formData} />;
      // case 6: return <ComplianceForm handleChange={handleChange} formData={formData} />;
      case 5: return <ProfileForm handleChange={handleChange} formData={formData} />;
      case 6: return <SettlementForm handleChange={handleChange} formData={formData} />;
      case 7: return <SecurityForm handleChangeAnswers={handleChangeAnswers} formData={formData} questions={questions} />;
    //   case 8: return ;
      default: return <BusinessForm payoutCountryOptions={payoutCountryOptions} handleChange={handleChange} formData={formData} />;
    }
  };

  return (
    <Box display="flex" flexDirection={{ xs: "column", md: "row" }} height="100vh">
      
      {/* Left Banner Section */}
      <Box
        data-aos="fade-right"
        sx={{
          width: { xs: "100%", md: "70%" },
          height: "100vh",
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: { xs: "none", md: "block" },
        }}
      />

      {/* Right Form Section */}
      <Box
        data-aos="fade-left"
        sx={{
          width: { xs: "100%", md: "30%" },
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          bgcolor: colors.common.white,
          padding: { xs: 3, md: 5 },
          borderRadius: "10px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Box sx={{ textAlign: "center", mb: 2 }} data-aos="zoom-in">
          <img src={logo} alt="logo" height={70} />
          <Typography sx={{ mt: 2, fontWeight: "bold", marginBottom: "5px" }}>
            FORM {currentForm} OF {totalForms}
          </Typography>
          <LinearProgress
            variant="determinate"
            value={(currentForm / totalForms) * 100}
            sx={{
              width: "100%",
              maxWidth: { xs: "100%", sm: "400px", md: "500px" },
              mb: 2,
              height: { xs: 8, sm: 10, md: 12 },
              borderRadius: "50px",
              backgroundColor: "#f5f5f5",
              boxShadow: "inset 0 1px 3px rgba(0,0,0,0.2)",
              "& .MuiLinearProgress-bar": {
                backgroundImage: "linear-gradient(90deg, #43cea2, #185a9d)",
                borderRadius: "50px",
                transition: "width 0.8s ease-in-out",
              },
            }}
          />
        </Box>

        {/* Dynamic Form Section */}
        <Box sx={{ flexGrow: 1, overflowY: "auto" }}>{renderForm()}</Box>

            {/* Button Section */}
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                {currentForm > 1 && (
                    <Button
                    onClick={prevForm}
                    variant="outlined"
                    fullWidth
                    sx={{
                        padding: "12px",
                        fontSize: "1rem",
                        borderRadius: "8px",
                        color: "#fff",
                        backgroundColor: "#185a9d",
                        "&:hover": {
                        backgroundColor: "#185a9d",
                        color: "#fff",
                        },
                    }}
                    >
                    Back
                    </Button>
                )}

                <Button
                    onClick={nextForm}
                    variant="contained"
                    fullWidth
                    sx={{
                    padding: "12px",
                    fontSize: "1rem",
                    borderRadius: "8px",
                    backgroundColor: "#185a9d",
                    "&:hover": {
                        backgroundColor: "#1d4c7c",
                    },
                    }}
                    // disabled={currentForm === totalForms}
                >
                    Next
                </Button>
            </Stack>

            {currentForm === 1 && (
                <Typography
                    variant="body2"
                    sx={{
                        mt: 2,
                        // color: "primary.main",
                        cursor: "pointer",
                    }}
                >
                    Already have an account?{" "}
                    <Button
                        onClick={() => {sessionStorage.clear(); navigate("/DepositPortal")}}
                        color="primary"
                        sx={{ fontSize: "1rem", fontWeight: "bold" }}
                    >
                        Login
                    </Button>
                </Typography>
            )}
        </Box>
    </Box>
  );
};

const FormLayout = ({ heading, fields, handleChange, formData }) => {
  return (
    <div>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", color: "#185a9d" }}>
            {heading}
        </Typography>
        <Stack spacing={2}>
            {fields.map((field) => {
                if (field.type === "multiselect") {
                    return (
                        <FormControl key={field.name} fullWidth margin="normal">
                            <Autocomplete
                              multiple
                              id="checkboxes-tags-demo"
                              options={field.options}
                              disableCloseOnSelect
                              getOptionLabel={(option) => option.label || ""}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.label}
                                </li>
                              )}
                              fullWidth
                              renderTags={(value) =>
                                value.length > 0 ? `${value.length} value(s) selected` : ""
                              }
                              value={
                                Array.isArray(formData[field.name])
                                  ? field.options.filter((opt) =>
                                      formData[field.name]
                                        .map(String)
                                        .includes(String(opt.value))
                                    )
                                  : typeof formData[field.name] === "string"
                                  ? field.options.filter((opt) =>
                                      formData[field.name]
                                        .split(",")
                                        .map((v) => v.trim())
                                        .includes(String(opt.value))
                                    )
                                  : []
                              }
                              onChange={(event, newValue) => {
                                const syntheticEvent = {
                                  target: {
                                    value: newValue.map((item) => item.value),
                                  },
                                };
                                handleChange(syntheticEvent, field.name);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label={field.label} />
                              )}
                            />
                            </FormControl>


                    );
                }

                if (field.type === "select") {
                    return (
                        <FormControl key={field.name} fullWidth margin="normal">
                        <InputLabel>{field.label}</InputLabel>
                        <Select
                            label={field.label}
                            value={formData[field.name] || ""}
                            onChange={(e) => handleChange(e, field.name)}
                        >
                            {field.options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                            ))}
                        </Select>
                        </FormControl>
                    );
                }


                if (field.type === "date") {
                    return (
                        <TextField
                            label={field.label}
                            type="date"
                            value={formData[field.name] || ''}
                            onChange={(e) => handleChange(e, field.name)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                            margin="normal"
                        />
                    );
                }

                return (
                    <TextField
                        key={field.name}
                        label={field.label}
                        name={field.name}
                        type={field.type || "text"}
                        size="small"
                        value={formData[field.name] || ""}
                        onChange={(e) => handleChange(e, field.name)}
                        fullWidth
                        margin="normal"
                    />
                );
            })}
        </Stack>
    </div>
  );
};

const BusinessForm = (props) => {
    const { payoutCountryOptions = [] } = props;
  
    return (
      <FormLayout
        {...props}
        heading="Business Information"
        fields={[
          { label: "Business Name", name: "bname", type:"text" },
          { label: "Registered Number", name: "busines_Code", type:"text" },
          { label: "Address Of Business", name: "blocation", type:"text" },
          { label: "Country of Incorporation", name: "busines_Country", type:"text" },
          { label: "Date Of Incorporation", name: "company_website_target_live_date", type: "date" },
          {
            label: "Countries For Payout",
            name: "payoutCountries",
            type: "multiselect",
            options: payoutCountryOptions,
          },
          { label: "Trading AS", name: "trading_dba", type: "text" },
          { label: "First Name", name: "fname", type: "text" },
          { label: "Last Name", name: "lname", type: "text" },
          { label: "Email", name: "main_contact_email", type: "email" },
        ]}
      />
    );
};
  
const SolutionsForm = (props) => {
    const { payoutCountryOptions = [] } = props;
  
    return (
      <FormLayout
            {...props}
            heading="Solutions Apply For"
            fields={[
                {
                    label: "Countries",
                    name: "solution_apply_for_country",
                    type: "multiselect",
                    options: payoutCountryOptions,  
                },
                {
                    label: "Mode Of Solutions",
                    name: "mode_of_solution",
                    type: "multiselect",
                    options: [
                        { value: '1', label: 'Card Processing' },
                        { value: '2', label: 'Alternative Payment Modes (Deposit)' },
                        { value: '10', label: 'Payout (Withdrawal)' },
                        { value: '11', label: 'Settlement' },
                        { value: '12', label: 'Batch Payout' }
                    ],
                },
            ]}
        />
    );
};

const DirectorsForm = (props) => (
    <Box>
      <FormLayout 
        {...props}
        heading="Director 1's Info" 
        fields={[ { label: "Name", name: "director1_name" }, { label: "Date Of Birth", name: "director1_dob" }, { label: "Nationality", name: "director1_nationality" }]}
      />
  
      <Box sx={{ mt: 3 }} />
  
      <FormLayout
        {...props} 
        heading="Director 2's Info (*Optional)" 
        fields={[ { label: "Name", name: "director2_name" }, { label: "Date Of Birth", name: "director2_dob" }, { label: "Nationality", name: "director2_nationality" }]}
      />
    </Box>
);

const ShareholderForm = (props) => (
    <Box>
      <FormLayout 
        {...props}
        heading="Shareholder 1's Info" 
        fields={[ { label: "Name", name: "shareholder1_name" }, { label: "Date Of Birth", name: "shareholder1_dob" }, { label: "Nationality", name: "shareholder1_nationality" }]}
      />
  
      <Box sx={{ mt: 3 }} />
  
      <FormLayout
        {...props}
        heading="Shareholder 2's Info (*Optional)" 
        fields={[ { label: "Name", name: "shareholder2_name" }, { label: "Date Of Birth", name: "shareholder2_dob" }, { label: "Nationality", name: "shareholder2_nationality" }]}
      />
    </Box>
);
  
const ComplianceForm = (props) => <FormLayout {...props} heading="Contact Details For MLRO/Complaince Officer" fields={[ { label: "Name", name: "comp_officer_name" }, { label: "Contact", name: "comp_officer_phone" }, { label: "Email", name: "comp_officer_email" }, { label: "Address", name: "comp_officer_address" }]} />;

const ProfileForm = (props) => <FormLayout {...props} heading="Business Profile" fields={[ { label: "Website/Processing URL", name: "website" }, { label: "Nature Of Business", name: "job_title" }, { label: "Estimate Monthly Volume", name: "company_estimated_monthly_volume" }, { label: "Average Ticket Size (in USD)", name: "company_avarage_ticket_size" }]} />;

const SettlementForm = (props) => (
    <FormLayout
      {...props}
      heading="Settlement Info"
      fields={[
        {
          label: "Settlement Currency",
          name: "settle_currency",
          type: "select",
          options: [
            { label: "INR", value: "INR" },
            { label: "USD", value: "USD" },
            { label: "EUR", value: "EUR" },
            { label: "USDT", value: "USDT" },
          ],
        },
        {
          label: "Crypto Wallet (Optional)",
          name: "usdt_wallet_address",
        },
      ]}
    />
);  

const SecurityForm = ({ handleChangeAnswers, formData, questions }) => {
    return (
      <Box>
        {questions.map((question, index) => (
          <Box key={index} mb={2}>
            <Typography variant="subtitle1" fontWeight="bold">
              {question.label}
            </Typography>
            <TextField
              fullWidth
              name={question.name}
              value={formData[question.name]?.value || ""}
              onChange={(e) => handleChangeAnswers(e, question)}
              placeholder="Enter your answer"
              variant="outlined"
              margin="normal"
            />
          </Box>
        ))}
      </Box>
    );
};
  

export default IncompleteProfile;
